import {
  Box,
  Button,
  // Button,
  DialogDescription,
  DialogTitle,
  Typography,
  useToastStore,
} from '@branch-messenger/willow-ui'
import { useQuery } from '@tanstack/react-query'
import { FC, use, useEffect } from 'react'

import EmailVerification from '@/assets/illustrations/email-verification.svg?react'
import { VerificationTimer } from '@/components/verification/VerificationTimer'
import { DialogContext } from '@/context'
import { userQueryOptions } from '@/queries/auth'
import {
  useSendEmailDeepLinkForPhoneUpdate,
  useSendOTPForPhoneUpdate,
} from '@/queries/registration/registration'
import { useAccountManagementStore } from '@/store/accountManagement/accountManagement'

import { EmailOTPModalContentProps } from '../types'

export const EmailDeepLinkModalContent: FC<EmailOTPModalContentProps> = ({
  email,
  phone,
}) => {
  const isPhoneUpdate = !!phone
  const addToast = useToastStore(state => state.addToast)
  const setEditingItem = useAccountManagementStore(
    state => state.setEditingItem
  )

  const { hideDialog } = use(DialogContext)
  const { mutate: sendEmailDeepLinkForPhoneUpdate } =
    useSendEmailDeepLinkForPhoneUpdate()

  const {
    mutate: sendOTPForPhoneUpdate,
    isPending: isSendingOTPForPhoneUpdate,
  } = useSendOTPForPhoneUpdate()

  //polling to check user has verified email
  const { data } = useQuery({
    ...userQueryOptions,
    refetchInterval: 1000,
    enabled: !isPhoneUpdate,
  })

  useEffect(() => {
    if (!isPhoneUpdate && data?.email === email && data?.email_verified) {
      hideDialog()
      addToast({ variant: 'success', title: 'Email successfully updated' })
      setEditingItem('none')
    }
  }, [data, email, isPhoneUpdate, hideDialog, addToast, setEditingItem])

  return (
    <Box>
      <Box $mb={4}>
        <Box $display="flex" $justify="center" $align="center" $mb={6}>
          <EmailVerification />
        </Box>
        <DialogTitle>Check your email for security confirmation.</DialogTitle>
      </Box>
      <Box $mb={2}>
        <DialogDescription>
          {`To keep your account safe, please verify it's you using the verification
        link sent to: `}
          <Typography as="span" $bold>
            {email}
          </Typography>
        </DialogDescription>
      </Box>
      <Box $mb={6}>
        <Typography $bold>Do not share this link with anyone.</Typography>
      </Box>
      {phone && (
        <Box $display="flex" $gap={4} $direction="column" $align="initial">
          <VerificationTimer
            type="email"
            onResendCode={sendEmailDeepLinkForPhoneUpdate}
          />
          <Box $display="flex" $justify="flex-end" $gap={2}>
            <Button
              type="button"
              color="tertiary"
              variant="outlined"
              onClick={hideDialog}
            >
              Cancel
            </Button>
            <Button
              disabled={isSendingOTPForPhoneUpdate}
              loading={isSendingOTPForPhoneUpdate}
              onClick={() => sendOTPForPhoneUpdate(phone)}
            >
              Continue
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  )
}
